export const UNSTAKING_WILL_BURN = "https://cadio.gitbook.io/cad/rewards";

export const VESTING_REWARDS =
  "https://cadenceprotocol.gitbook.io/cadence-protocol/achievements-and-rewards/vesting-rewards";

export const STAKING_INSURANCE =
  "https://app.insurace.io/Insurance/Cart?id=124&referrer=545066382753150189457177837072918687520318754040";
